import { Component } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: '[gbc-table-chevron-header]',
    templateUrl: './table-chevron-header.component.html',
    styleUrls: ['./table-chevron-header.component.scss'],
})
export class TableChevronHeaderComponent {
  constructor() {}
}
